import React from 'react'
import styled from "styled-components"

import { Link as InternalLink } from "gatsby"

import { typeHeading02, typeHeading04, typeBody02, typeLabel01 } from '../../theme/typography'
import { grid, row, column } from '../../theme/grid'
import { spacer, unit, pixelate, margin, SIZE, mediaQuery } from '../../theme/metrics'
import { WHITE_01 } from '../../theme/colors'

import { button } from '../../theme/core';

import { StyledButtons } from '../../theme/components'


export const Inner = styled.div`
	${row({medium:true})}
	
`

export const Content = styled.div`
	${props => column({medium:{span:12}},{direction:props.theme.direction})}
	
`

export const Background = styled.div`
	background-color: ${props => props.theme.background};
	padding-left: ${margin(SIZE.small)};
	padding-right: ${margin(SIZE.small)};

	${mediaQuery[SIZE.medium]}{
		padding-left: 0;
		padding-right: 0;
	}
`

export const Row = styled.div`
	${props => row({medium:true})}
`

export const ContentContainer = styled.div`
	${props => column({medium:{span:5,before:1,after:1}},{direction:props.theme.direction})}

	padding-top: ${unit(8)};
	padding-bottom: ${unit(8)};

	${mediaQuery[SIZE.large]}{
		padding-top: ${spacer(3)};
		padding-bottom: ${spacer(3)};
	}
`

export const ImageContainer = styled.div`
	${props => column({medium:{span:4,after:1}},{direction:props.theme.direction})}
	position: relative;
	display: flex;
	justify-content: center;
`

export const Image = styled.img`
	width: 100%;
	height: 100%;
	display: block;
	// position: absolute !important;

	${mediaQuery[SIZE.medium]}{
		height: 100%;
		object-fit: contain;
	}

`

export const Heading = styled.div`
	${typeHeading02}
	color: ${props => props.theme.foreground};
	padding-bottom: ${spacer(1)};
`

export const Text = styled.div`
	${typeBody02}
	color: ${props => props.theme.foreground};
	padding-bottom: ${spacer(1)};
`

export const Links = styled(StyledButtons)`
`